module.exports = __webpack_public_path__ + "static/media/7D.ad4ce2f5.jpg";